import React from 'react';
import { useTranslation } from 'react-i18next';

export const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer id="contact" className="border-t border-white/5 bg-black py-4 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto text-center">
        <p className="text-sm text-white/80 sm:text-base">
          {t('footer-copyright')}
        </p>
      </div>
    </footer>
  );
};
